import React from "react";
import { Grid } from "@material-ui/core";
import ChooseDropdown from "../e_co2_emission/view/e_co2_emission_dropdown";

export default function E_CO2_EMISSION(){
    return(
        <>
            <ChooseDropdown/>
        </>
    )
}